export class AnswerType {
  constructor(
    public type: string,
    public operators : string[]
  ){}

  copy() : AnswerType {
    return new AnswerType(this.type, Array.from(this.operators));
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/answer-type.ts